import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ServiceCards from './components/ServiceCards';
import AboutSection from './components/AboutSection';
import TestimonialSlider from './components/TestimonialSlider';
import BlogSection from './components/BlogSection';
import AppointmentSection from './components/AppointmentSection';

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <ServiceCards />
        <AboutSection />
        <TestimonialSlider />
        <BlogSection />
        <AppointmentSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}